import Icon from "@ant-design/icons";
import { ReactComponent as SettingsSvg } from "./svg/settings.svg";

const SettingsIcon = (props) => <Icon component={SettingsSvg} {...props} />;

export default SettingsIcon;
